import { render, staticRenderFns } from "./calfSelectionWaiting.vue?vue&type=template&id=66a84389&scoped=true&"
import script from "./calfSelectionWaiting.vue?vue&type=script&lang=js&"
export * from "./calfSelectionWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a84389",
  null
  
)

export default component.exports